import { ArrowUpRight, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-nova-line bg-nova-bg overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-6">
            <div className="mono-label mb-4">[ Nova Creations Codes ]</div>
            <p className="font-display font-black tracking-tighter text-5xl lg:text-7xl text-nova-text leading-[0.9]">
              Let's build<br />something <span className="gold-text italic font-light">unforgettable</span>.
            </p>
            <a href="mailto:novacreationscodes@gmail.com?subject=New%20Project%20Inquiry%20—%20Nova%20Creations%20Codes&body=Hi%2C%0A%0AI'd%20like%20to%20start%20a%20project%20with%20Nova%20Creations%20Codes.%0A%0AName%3A%0ACompany%3A%0APhone%3A%0AService%20interest%3A%0ABudget%20(USD)%3A%0AProject%20description%3A%0A%0AThanks!" className="inline-flex items-center gap-2 mt-10 px-7 py-4 bg-nova-gold text-nova-bg hover:bg-[#C9F9D6] transition-colors" data-testid="footer-cta">
              Start a Project
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>

          <div className="lg:col-span-2">
            <div className="mono-label mb-5">Explore</div>
            <ul className="space-y-3 text-nova-mute">
              <li><a href="#services" className="hover:text-nova-text transition-colors">Services</a></li>
              <li><a href="#process" className="hover:text-nova-text transition-colors">Process</a></li>
              <li><a href="#pricing" className="hover:text-nova-text transition-colors">Pricing</a></li>
              <li><a href="#about" className="hover:text-nova-text transition-colors">About</a></li>
              <li><a href="#contact" className="hover:text-nova-text transition-colors">Contact</a></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="mono-label mb-5">Direct</div>
            <ul className="space-y-3 text-nova-mute">
              <li><a href="tel:+916260943446" className="hover:text-nova-text">+91 6260943446</a></li>
              <li><a href="mailto:novacreationscodes@gmail.com" className="hover:text-nova-text">novacreationscodes@gmail.com</a></li>
            </ul>
            <div className="flex items-center gap-3 mt-6">
              <a href="https://wa.me/916260943446" target="_blank" rel="noreferrer" aria-label="WhatsApp" data-testid="footer-whatsapp" className="w-10 h-10 grid place-items-center border border-nova-line hover:border-nova-gold/40 hover:text-nova-gold transition-colors">
                <MessageCircle className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Massive logo */}
        <div className="border-t border-nova-line pt-10 pb-6">
          <div className="font-display font-black tracking-tighter text-[clamp(3rem,16vw,12rem)] leading-[0.85] text-nova-text/[0.06] select-none">
            NOVA CREATIONS
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-6 border-t border-nova-line text-nova-mute text-sm">
          <span>© {new Date().getFullYear()} Nova Creations Codes. All rights reserved.</span>
          <span className="mono-label">Crafted with code & coffee ☕</span>
        </div>
      </div>
    </footer>
  );
}
